import { PropsWithChildren, ReactNode } from 'react';
import { AvatarInput, CustomAvatarProps } from '@ds';
import { LOGO_IMAGE_TYPES } from '@/constants/file.constants';
import { TMDXFile } from '@/api/apis/files';

type AdminFormSectionProps = {
  title: string;
  startContent?: ReactNode;
  withAvatar?: boolean;
  imageUrl?: string;
  name?: string | null;
  type?: CustomAvatarProps['type'];
  fallbackInitials?: CustomAvatarProps['fallbackInitials'];
  isReadOnly?: boolean;
  isPrimary?: boolean;
  onImageChange?: (file: TMDXFile) => void;
};

export const AdminFormSection = ({
  title,
  startContent,
  withAvatar = false,
  fallbackInitials = true,
  imageUrl,
  name,
  type,
  onImageChange = () => {},
  isReadOnly = false,
  isPrimary = false,
  children,
}: PropsWithChildren<AdminFormSectionProps>) => {
  return (
    <div className="flex flex-col w-full p-7 rounded-lg bg-base-80 shadow-sm gap-6">
      <p className="text-hm font-semibold font-secondary">{title}</p>
      {startContent}
      {withAvatar ? (
        <div className="flex gap-6">
          <div className="flex flex-col gap-4 items-center shrink-0">
            <AvatarInput
              src={imageUrl}
              radius="xxl"
              disabled={isReadOnly}
              isBordered
              color="primary"
              size="xxl"
              type={type}
              avatarProps={{
                name,
                fallbackInitials,
              }}
              onFileChange={onImageChange}
              accept={LOGO_IMAGE_TYPES}
            />
            {isPrimary && <span className="block px-1 rounded-lg text-s-r bg-white text-base-5">Primary</span>}
          </div>
          <div className="flex grow flex-col gap-5">{children}</div>
        </div>
      ) : (
        <div className="flex grow flex-col gap-5">{children}</div>
      )}
    </div>
  );
};
